import * as moment from "moment"
import {momentBookingDateToBackendString} from "./model/time"
import {assertNever} from "./tsutil"
import {FlightTypeEnum} from "./graphql/queries"
import {BookingFormAirportState} from "./state"

export type AirportField = "airlineCode" | "flightType" | "flightNumber"

export function updateAirportStop(
  state: BookingFormAirportState,
  field: AirportField,
  value: string,
): BookingFormAirportState {
  switch (field) {
    case "airlineCode":
      return {...state, airlineCode: value}
    case "flightType":
      return {...state, flightType: value as FlightTypeEnum}
    case "flightNumber":
      return {...state, flightNumber: value}
    default:
      return assertNever(field)
  }
}

export function defaultBookingDate(): string {
  return momentBookingDateToBackendString(
    moment()
      .add(1, "days")
      .startOf("hour"),
  )
}



// WEBPACK FOOTER //
// ./src/reducers.ts